/*
    EG Megamenu Image
    © 2022 EcomGraduates
    https://wwww.ecomgraduates.com
*/

document.querySelectorAll('.mega-menu__link').forEach(elem => {
    if (elem.textContent.includes('|')) {
        const title = elem.textContent.split('|')[0].replace(/[\n\r]+|[\s]{2,}/g, ' ').trim()
        const img = elem.textContent.split('|')[1].replace(/[\n\r]+|[\s]{2,}/g, ' ').trim()
        elem.innerHTML = `
            <img
                src="${img}"
                alt=""
                width=""
                height=""
                style="max-width: 100%; height:450px;
  display:block;
    object-fit: cover;
    min-width: 100%;
    margin:auto;">
            <div class="button--secondary link-menu" style="text-align:">
                ${title}
            </div>
        `
        elem.closest('.mega-menu__list').style.gridTemplateColumns = 'repeat(5, minmax(0, 1fr))'
    }
})

document.querySelectorAll('.menu-drawer__menu-item').forEach(elem => {
    if (elem.textContent.includes('|')) {
        const title = elem.textContent.split('|')[0].replace(/[\n\r]+|[\s]{2,}/g, ' ').trim()
        const img = elem.textContent.split('|')[1].replace(/[\n\r]+|[\s]{2,}/g, ' ').trim()
        elem.innerHTML = `
            <div class="image-menu">
                <img
                    src="${img}"
                    alt=""
                    width=""
                    height=""
                   style="max-width: 100%; height: 350px;
  
    object-fit: cover;
    min-width: 100%;
    margin:auto;">
                <div class="link-menu" style="text-align: center">
                    ${title}
                </div>
            </div>
        `
    }
})
